import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { useTranslation } from 'react-i18next';
import InputControl from '../Components/Utility/Controls/InputControl';
import { SelectControl } from '../Components/Utility/Controls/SelectControl';
import SearchControl from '../Components/Utility/Controls/searchControl';
import TextareaControl from '../Components/Utility/Controls/TextareaControl';
import CheckboxControl from '../Components/Utility/Controls/CheckboxControl';
import CheckboxLabelControl from '../Components/Utility/Controls/CheckboxLabelControl';
import RadioControl from '../Components/Utility/Controls/RadioControl';
import ConfirmationModal from '../Components/Utility/Controls/ConfirmationModal';
import ModalLarge from '../Components/Utility/Controls/ModalLarge';
import ModalMedium from '../Components/Utility/Controls/ModalMedium';
import UploadImage from '../Components/Utility/Controls/UploadImage';
import ListingCard from '../Components/Utility/Controls/ListingCard';
import NewListing from '../Components/Utility/Controls/NewListing';
import ListingCardImage from '../Components/Utility/Controls/ListingCardImage';
import CustomTable from '../Components/Utility/Controls/CustomTable';
import { AGGridTable, AGValidatedCell } from '../Components/AG-GridTable';
import CommonAGGridTable from '../Components/CommonAGGridTable';
import CollapseCard from '../Components/Utility/Controls/CollapseCard';
import CustomTabs from '../Components/Utility/Controls/CustomTabs';
import SearchExpandable from '../Components/Utility/Controls/SearchExpandable';

const DEMO_COLUMNS = [
  { field: 'id', headerName: 'ID', width: 80, searchable: false },
  { field: 'productNumber', headerName: 'Product Number', required: true, width: 170 },
  { field: 'productTitle', headerName: 'Product Title', required: true, width: 160 },
  { field: 'description', headerName: 'Description', width: 200 },
  { field: 'brand', headerName: 'Brand', required: true, width: 130 },
  { field: 'subBrand', headerName: 'Sub Brand', width: 130 },
  { field: 'productType', headerName: 'Product Type', required: true, width: 150 },
  { field: 'category', headerName: 'Category', width: 130 },
];

const DEMO_ROWS = [
  {
    id: '1',
    productNumber: 'CFR-001',
    productTitle: 'Classic Tee',
    description: 'Basic cotton t-shirt',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '2',
    productNumber: 'CFR-002',
    productTitle: 'Slim Fit Jeans',
    description: 'Dark wash denim',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 2',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '3',
    productNumber: 'CFR-003',
    productTitle: 'Hooded Sweatshirt',
    description: 'Fleece-lined hoodie',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 3',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '4',
    productNumber: 'CFR-004',
    productTitle: 'Cargo Shorts',
    description: '100% cotton cargo',
    brand: 'Brand 3',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '5',
    productNumber: 'CFR-005',
    productTitle: 'Polo Shirt',
    description: 'Pique polo shirt',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 2',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '6',
    productNumber: 'CFR-006',
    productTitle: 'Chino Trousers',
    description: 'Slim chino trousers',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 4',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '7',
    productNumber: 'CFR-007',
    productTitle: 'Puffer Jacket',
    description: 'Water-resistant puffer',
    brand: 'Brand 3',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Outerwear',
  },
  {
    id: '8',
    productNumber: 'CFR-008',
    productTitle: 'Linen Shirt',
    description: 'Breathable linen shirt',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 3',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '1',
    productNumber: 'CFR-001',
    productTitle: 'Classic Tee',
    description: 'Basic cotton t-shirt',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '2',
    productNumber: 'CFR-002',
    productTitle: 'Slim Fit Jeans',
    description: 'Dark wash denim',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 2',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '3',
    productNumber: 'CFR-003',
    productTitle: 'Hooded Sweatshirt',
    description: 'Fleece-lined hoodie',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 3',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '4',
    productNumber: 'CFR-004',
    productTitle: 'Cargo Shorts',
    description: '100% cotton cargo',
    brand: 'Brand 3',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '5',
    productNumber: 'CFR-005',
    productTitle: 'Polo Shirt',
    description: 'Pique polo shirt',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 2',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '6',
    productNumber: 'CFR-006',
    productTitle: 'Chino Trousers',
    description: 'Slim chino trousers',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 4',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '7',
    productNumber: 'CFR-007',
    productTitle: 'Puffer Jacket',
    description: 'Water-resistant puffer',
    brand: 'Brand 3',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Outerwear',
  },
  {
    id: '8',
    productNumber: 'CFR-008',
    productTitle: 'Linen Shirt',
    description: 'Breathable linen shirt',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 3',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '1',
    productNumber: 'CFR-001',
    productTitle: 'Classic Tee',
    description: 'Basic cotton t-shirt',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '2',
    productNumber: 'CFR-002',
    productTitle: 'Slim Fit Jeans',
    description: 'Dark wash denim',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 2',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '3',
    productNumber: 'CFR-003',
    productTitle: 'Hooded Sweatshirt',
    description: 'Fleece-lined hoodie',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 3',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '4',
    productNumber: 'CFR-004',
    productTitle: 'Cargo Shorts',
    description: '100% cotton cargo',
    brand: 'Brand 3',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '5',
    productNumber: 'CFR-005',
    productTitle: 'Polo Shirt',
    description: 'Pique polo shirt',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 2',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '6',
    productNumber: 'CFR-006',
    productTitle: 'Chino Trousers',
    description: 'Slim chino trousers',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 4',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '7',
    productNumber: 'CFR-007',
    productTitle: 'Puffer Jacket',
    description: 'Water-resistant puffer',
    brand: 'Brand 3',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Outerwear',
  },
  {
    id: '8',
    productNumber: 'CFR-008',
    productTitle: 'Linen Shirt',
    description: 'Breathable linen shirt',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 3',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '1',
    productNumber: 'CFR-001',
    productTitle: 'Classic Tee',
    description: 'Basic cotton t-shirt',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '2',
    productNumber: 'CFR-002',
    productTitle: 'Slim Fit Jeans',
    description: 'Dark wash denim',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 2',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '3',
    productNumber: 'CFR-003',
    productTitle: 'Hooded Sweatshirt',
    description: 'Fleece-lined hoodie',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 3',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '4',
    productNumber: 'CFR-004',
    productTitle: 'Cargo Shorts',
    description: '100% cotton cargo',
    brand: 'Brand 3',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '5',
    productNumber: 'CFR-005',
    productTitle: 'Polo Shirt',
    description: 'Pique polo shirt',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 2',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '6',
    productNumber: 'CFR-006',
    productTitle: 'Chino Trousers',
    description: 'Slim chino trousers',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 4',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '7',
    productNumber: 'CFR-007',
    productTitle: 'Puffer Jacket',
    description: 'Water-resistant puffer',
    brand: 'Brand 3',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Outerwear',
  },
  {
    id: '8',
    productNumber: 'CFR-008',
    productTitle: 'Linen Shirt',
    description: 'Breathable linen shirt',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 3',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '1',
    productNumber: 'CFR-001',
    productTitle: 'Classic Tee',
    description: 'Basic cotton t-shirt',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '2',
    productNumber: 'CFR-002',
    productTitle: 'Slim Fit Jeans',
    description: 'Dark wash denim',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 2',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '3',
    productNumber: 'CFR-003',
    productTitle: 'Hooded Sweatshirt',
    description: 'Fleece-lined hoodie',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 3',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '4',
    productNumber: 'CFR-004',
    productTitle: 'Cargo Shorts',
    description: '100% cotton cargo',
    brand: 'Brand 3',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '5',
    productNumber: 'CFR-005',
    productTitle: 'Polo Shirt',
    description: 'Pique polo shirt',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 2',
    productType: 'Physical',
    category: 'Tops',
  },
  {
    id: '6',
    productNumber: 'CFR-006',
    productTitle: 'Chino Trousers',
    description: 'Slim chino trousers',
    brand: 'Brand 1',
    subBrand: 'Sub Brand 4',
    productType: 'Physical',
    category: 'Bottoms',
  },
  {
    id: '7',
    productNumber: 'CFR-007',
    productTitle: 'Puffer Jacket',
    description: 'Water-resistant puffer',
    brand: 'Brand 3',
    subBrand: 'Sub Brand 1',
    productType: 'Physical',
    category: 'Outerwear',
  },
  {
    id: '8',
    productNumber: 'CFR-008',
    productTitle: 'Linen Shirt',
    description: 'Breathable linen shirt',
    brand: 'Brand 2',
    subBrand: 'Sub Brand 3',
    productType: 'Physical',
    category: 'Tops',
  },
];

const DEMO_MORE_ACTIONS = [
  { label: 'View History', icon: 'icon-history', onClick: (row) => alert(`History: ${row.productTitle}`) },
  { label: 'Download PDF', icon: 'icon-download', onClick: (row) => alert(`Download: ${row.productTitle}`) },
  { divider: true },
  { label: 'Delete', icon: 'icon-delete', onClick: (row) => alert(`Delete: ${row.productTitle}`), danger: true },
];

const DEMO_FLOATING_ACTIONS = [
  { icon: 'icon-add-new', label: 'Add', onClick: () => alert('Add') },
  { divider: true },
  { icon: 'icon-archive', label: 'Archive', onClick: () => alert('Archive') },
  { icon: 'icon-status', label: 'Status', onClick: () => alert('Status') },
  { divider: true },
  { icon: 'icon-new-table', label: 'Table View', onClick: () => alert('Toggle view') },
];

const VALIDATED_INITIAL_ROWS = [
  { id: 'v1', itemName: '', code: 'LC-001', maxChars: 30 },
  { id: 'v2', itemName: 'Fabric Cost', code: 'LC-002', maxChars: 30 },
  { id: 'v3', itemName: '', code: 'LC-003', maxChars: 10 },
];

function makeValidatedColumns(handleValueChange, getError, borderOn, messageOn) {
  return [
    {
      field: 'itemName',
      headerName: 'Item Name',
      flex: 2,
      cellRenderer: AGValidatedCell,
      cellRendererParams: (params) => ({
        placeholder: 'Enter Item Name',
        maxLength: params.data?.maxChars ?? 30,
        onValueChange: handleValueChange,
        getError,
        showErrorBorder: borderOn,
        showErrorMessage: messageOn,
      }),
    },
    { field: 'code', headerName: 'Code', flex: 1, searchable: false },
  ];
}

function AGValidatedCellDemo() {
  const { useState: useLocalState } = React;
  const [rows, setRows] = useLocalState(VALIDATED_INITIAL_ROWS.map((r) => ({ ...r })));

  const handleValueChange = (data, field, newValue) => {
    setRows((prev) => prev.map((r) => (r.id === data.id ? { ...r, [field]: newValue } : r)));
  };

  const getError = (data, field) => {
    if (field === 'itemName' && !data.itemName) return `${data.code} — Column Title is required`;
    return null;
  };

  const gridOptions = {
    getRowHeight: AGValidatedCell.getRowHeight(getError, ['itemName'], 68, 40),
  };

  const sharedProps = {
    rowData: rows,
    selectionEnabled: false,
    showColumnSearch: false,
    showColumnMenuButton: false,
    height: '220px',
    gridOptions,
  };

  return (
    <div className="row mt-2">
      <div className="col-md-4">
        <p className="f-12 font-weight-bold mb-1">Case 1 — Red border + message</p>
        <AGGridTable {...sharedProps} columnDefs={makeValidatedColumns(handleValueChange, getError, true, true)} />
      </div>
      <div className="col-md-4">
        <p className="f-12 font-weight-bold mb-1">Case 2 — Red border only</p>
        <AGGridTable {...sharedProps} columnDefs={makeValidatedColumns(handleValueChange, getError, true, false)} />
      </div>
      <div className="col-md-4">
        <p className="f-12 font-weight-bold mb-1">Case 3 — Message only</p>
        <AGGridTable {...sharedProps} columnDefs={makeValidatedColumns(handleValueChange, getError, false, true)} />
      </div>
    </div>
  );
}

const UOM_OPTIONS = [
  { value: 'pcs', label: 'Pcs' },
  { value: 'm', label: 'Metre' },
  { value: 'cm', label: 'Centimetre' },
  { value: 'kg', label: 'Kg' },
  { value: 'g', label: 'Gram' },
  { value: 'l', label: 'Litre' },
  { value: 'ml', label: 'Millilitre' },
  { value: 'hr', label: 'Hour' },
  { value: 'day', label: 'Day' },
  { value: 'set', label: 'Set' },
  { value: 'pair', label: 'Pair' },
  { value: 'box', label: 'Box' },
];

function CommonAGGridTableDemo() {
  const [rows, setRows] = React.useState([
    { id: 'r1', item: 'Pattern Making', qty: '2', uom: 'hr', pricePerUnit: '45', totalPrice: '90', exclude: false },
    { id: 'r2', item: 'Sample Cutting', qty: '5', uom: 'pcs', pricePerUnit: '12.5', totalPrice: '62.5', exclude: false },
    { id: 'r3', item: 'Fabric Swatch', qty: '3', uom: 'm', pricePerUnit: '8.75', totalPrice: '26.25', exclude: true },
  ]);

  const columnDefs = [
    {
      field: 'item',
      headerName: 'Item',
      cellType: 'text',
      minWidth: 200,
      flex: 1,
    },
    {
      field: 'qty',
      headerName: 'Quantity',
      cellType: 'text',
      width: 140,
      mainMenuItems: ['sortAscending', 'sortDescending', 'separator', 'autoSizeThis'],
    },
    {
      field: 'uom',
      headerName: 'UoM',
      cellType: 'select',
      width: 160,
      suppressHeaderMenuButton: true,
      cellProps: { options: UOM_OPTIONS, placeholder: 'Select' },
    },
    {
      field: 'pricePerUnit',
      headerName: 'Price Per Unit',
      cellType: 'currency',
      width: 160,
      sortable: false,
      lockPinned: true,
    },
    {
      field: 'totalPrice',
      headerName: 'Total Price',
      cellType: 'currency',
      width: 160,
      suppressColumnsToolPanel: true,
    },
    {
      field: 'exclude',
      headerName: 'Exclude',
      cellType: 'checkbox',
      width: 110,
      sortable: false,
      resizable: false,
      suppressHeaderMenuButton: true,
    },
  ];

  const handleRowChange = (rowId, field, value) => {
    setRows((prev) => prev.map((r) => (r.id === rowId ? { ...r, [field]: value } : r)));
  };

  const handleAddRow = () => {
    setRows((prev) => [
      ...prev,
      {
        id: `r${Date.now()}`,
        item: '',
        qty: '',
        uom: null,
        pricePerUnit: '',
        totalPrice: '',
        exclude: false,
      },
    ]);
  };

  const handleDeleteRow = (rowId) => {
    setRows((prev) => prev.filter((r) => r.id !== rowId));
  };

  return (
    <CommonAGGridTable
      revealHeaderControlsOnHover
      enableFillHandle
      columnDefs={columnDefs}
      rowData={rows}
      getRowId={(r) => r.id}
      onRowChange={handleRowChange}
      onAddRow={handleAddRow}
      onDeleteRow={handleDeleteRow}
    />
  );
}

const PRODUCTS_WITH_COLOURWAYS = [
  {
    id: 'p1',
    productNumber: 'CFR-001',
    productTitle: 'Classic Tee',
    brand: 'Brand 1',
    colourways: [
      { id: 'p1-c1', colourway: 'Red', size: 'M', qty: 100, pricePerUnit: '5.00', totalPrice: '500.00' },
      { id: 'p1-c2', colourway: 'Blue', size: 'M', qty: 80, pricePerUnit: '5.00', totalPrice: '400.00' },
      { id: 'p1-c3', colourway: 'Green', size: 'L', qty: 60, pricePerUnit: '5.00', totalPrice: '300.00' },
    ],
  },
  {
    id: 'p2',
    productNumber: 'CFR-002',
    productTitle: 'Slim Fit Jeans',
    brand: 'Brand 2',
    colourways: [
      { id: 'p2-c1', colourway: 'Indigo', size: '32', qty: 50, pricePerUnit: '22.00', totalPrice: '1100.00' },
      { id: 'p2-c2', colourway: 'Black', size: '34', qty: 40, pricePerUnit: '22.00', totalPrice: '880.00' },
    ],
  },
  {
    id: 'p3',
    productNumber: 'CFR-003',
    productTitle: 'Hooded Sweatshirt',
    brand: 'Brand 1',
    colourways: [],
  },
];

function ProductColourwaysDetail(params) {
  const product = params?.data;
  const childRows = product?.colourways || [];

  const detailColumnDefs = [
    { field: 'colourway', headerName: 'Colourway', cellType: 'readonlyText', minWidth: 140, flex: 1 },
    { field: 'size', headerName: 'Size', cellType: 'readonlyText', width: 100 },
    { field: 'qty', headerName: 'Quantity', cellType: 'readonlyText', width: 120 },
    { field: 'pricePerUnit', headerName: 'Price Per Unit', cellType: 'currency', width: 160 },
    { field: 'totalPrice', headerName: 'Total Price', cellType: 'currency', width: 160 },
  ];

  return (
    <div className="p-2" style={{ background: '#f5f7fa' }}>
      <CommonAGGridTable revealHeaderControlsOnHover columnDefs={detailColumnDefs} rowData={childRows} getRowId={(r) => r.id} readOnly />
    </div>
  );
}

function CommonAGGridTableExpandDemo() {
  const [rows] = React.useState(PRODUCTS_WITH_COLOURWAYS);

  const columnDefs = [
    { field: 'productNumber', headerName: 'Product Number', cellType: 'readonlyText', width: 170 },
    { field: 'productTitle', headerName: 'Product Title', cellType: 'readonlyText', minWidth: 200, flex: 1 },
    { field: 'brand', headerName: 'Brand', cellType: 'readonlyText', width: 150 },
    {
      colId: 'colourwayCount',
      headerName: '# Colourways',
      cellType: 'readonlyText',
      width: 140,
      cellProps: { accessor: (row) => row?.colourways?.length ?? 0 },
    },
  ];

  return (
    <CommonAGGridTable
      revealHeaderControlsOnHover
      columnDefs={columnDefs}
      rowData={rows}
      getRowId={(r) => r.id}
      readOnly
      detailRowRenderer={ProductColourwaysDetail}
      isRowMaster={(row) => Array.isArray(row?.colourways) && row.colourways.length > 0}
      gridOptions={{ detailRowAutoHeight: true }}
    />
  );
}

const RANGE_PLAN_TREE_ROWS = [
  { id: '2001644', path: ['2001644'], productNumber: '2001644', gradingGroup: 'Chintan', colourway: 'PINK', size: 'S' },
  { id: '2001644-c1', path: ['2001644', 'c1'], productNumber: '', gradingGroup: 'Chintan', colourway: 'PINK', size: 'M' },
  { id: '2001644-c2', path: ['2001644', 'c2'], productNumber: '', gradingGroup: 'Chintan', colourway: 'PINK', size: 'L' },
  { id: '2001644-c3', path: ['2001644', 'c3'], productNumber: '', gradingGroup: 'New Grad', colourway: 'PINK', size: 'l' },
  { id: '2001644-c4', path: ['2001644', 'c4'], productNumber: '', gradingGroup: 'New Grad', colourway: 'PINK', size: 'm' },
  { id: '2001644-c5', path: ['2001644', 'c5'], productNumber: '', gradingGroup: 'New Grad', colourway: 'PINK', size: 'x' },
  { id: 'ADEW00001', path: ['ADEW00001'], productNumber: 'ADEW00001', gradingGroup: 'NewGradbyChintan', colourway: 'Green', size: 'S' },
];

function CommonAGGridTableTreeExpandDemo() {
  const [rows] = React.useState(RANGE_PLAN_TREE_ROWS);

  const columnDefs = [
    { field: 'productNumber', headerName: 'Product Number', cellType: 'readonlyText', width: 180 },
    { field: 'gradingGroup', headerName: 'Grading Group', cellType: 'readonlyText', minWidth: 180, flex: 1 },
    { field: 'colourway', headerName: 'Colourway', cellType: 'readonlyText', width: 160 },
    { field: 'size', headerName: 'Size', cellType: 'readonlyText', width: 120 },
  ];

  return (
    <CommonAGGridTable
      revealHeaderControlsOnHover
      columnDefs={columnDefs}
      rowData={rows}
      getRowId={(r) => r.id}
      readOnly
      treeData
      getDataPath={(row) => row.path}
      groupDefaultExpanded={0}
    />
  );
}

function Utility() {
  const { t } = useTranslation('common');
  const [selectedIds, setSelectedIds] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({});

  return (
    <>
      {/* This is demo component */}
      <div className="container mt-3">
        <h3>{t('UTILITY.CONTROLS')}</h3>
        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <InputControl />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="form-group">
              <SelectControl />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="form-group">
              <SearchExpandable />
            </div>
          </div>
          <div className="col-md-12 mt-3">
            <h4>Table</h4>
            <CustomTable />
          </div>
          <div className="col-md-12 mt-3">
            <h4>Tab</h4>
            <CustomTabs />
          </div>
          {/* <div className="col-lg-4">
            <div className="form-group">
              <InputControlIcon />
            </div>
          </div> */}
          {/* <div className="col-lg-4">
            <div className="form-group">
              <MultiSelectControl />
            </div>
          </div> */}
          {/* Input with Add Icon */}
          <div className="col-lg-4">
            <div className="form-group d-flex">
              <div className="flex-fill">
                <InputControl />
              </div>
              <button className="btn btn-outline ml-2 label-top-margin">
                <i className="icon-add" />
              </button>
            </div>
          </div>
          {/* Input with Add Icon END */}
          <div className="col-lg-12">
            <div className="form-group">
              <TextareaControl />
            </div>
          </div>
          <div className="col-lg-12">
            <div>
              <h4>Search</h4>
              <SearchControl />
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-group">
              <CheckboxLabelControl />
            </div>
          </div>
          <div className="col-lg-2">
            <div className="form-group">
              <CheckboxControl />
            </div>
          </div>

          <div className="col-lg-2">
            <div className="d-flex switch-container align-items-center">
              <div className="switch-common d-flex design-switch">
                <input type="checkbox" className="form-check-input" id="customSwitch1" name="commentSwitch" />
                <label className="text-nowrap design-title" htmlFor="customSwitch1">
                  Switch
                </label>
              </div>
            </div>
            {/* Toggle Switch with Checkbox */}
            <div className="form-group">
              <div className="custom-control custom-switch">
                <input type="checkbox" className="custom-control-input" id="customSwitch1" />
                <label className="custom-control-label" htmlFor="customSwitch1" />
              </div>
            </div>
            {/* Toggle Switch with Checkbox END */}
          </div>
          {/* Popover */}
          <div className="col-lg-2">
            <label className="m-0 mr-3">{t('UTILITY.POPOVER')}</label>
            <OverlayTrigger
              placement="bottom"
              trigger="click"
              rootClose
              overlay={
                <Popover className="custom-popover">
                  <Popover.Content>{t('UTILITY.POPOVER_CONTENT')}</Popover.Content>
                </Popover>
              }
            >
              <i className="icon-add" />
            </OverlayTrigger>
          </div>
          {/* Popover END */}

          <div className="col-lg-6">
            <div className="form-group">
              <RadioControl />
            </div>
          </div>
          <div className="col-lg-2">
            <div className="form-group">
              <ConfirmationModal />
            </div>
          </div>
          <div className="col-lg-2">
            <div className="form-group">
              <ModalLarge />
            </div>
          </div>
          <div className="col-lg-2">
            <div className="form-group">
              <ModalMedium />
            </div>
          </div>
          <div className="col-lg-2">
            <div className="form-group">
              <UploadImage />
            </div>
          </div>
        </div>
        <h4 className="mt-3">{t('UTILITY.LISTING_CARD')}</h4>
        <div className="row">
          <div className="col-md-4">
            <ListingCard />
          </div>
          <div className="col-md-4">
            <NewListing />
          </div>
          <div className="col-md-4">
            <ListingCardImage />
          </div>
        </div>
        <h4 className="mt-3">{t('UTILITY.AG_GRID')}</h4>

        {/* Controlled selection demo: shows how selectedIds + onSelectionChanged wire up */}
        <div className="d-flex align-items-center mb-2" style={{ gap: 8 }}>
          <span className="f-12 text-muted">Selected IDs:</span>
          <span className="f-12 font-weight-bold">{selectedIds.join(', ') || 'none'}</span>
          <button className="btn btn-outline btn-sm ml-auto" onClick={() => setSelectedIds([])}>
            Deselect All
          </button>
          <button className="btn btn-default btn-sm" onClick={() => setSelectedIds(DEMO_ROWS.map((r) => r.id))}>
            Select All
          </button>
        </div>

        <AGGridTable
          columnDefs={DEMO_COLUMNS}
          rowData={DEMO_ROWS}
          rowIdField="id"
          selectedRowIds={selectedIds}
          onSelectionChanged={(rows) => setSelectedIds(rows.map((r) => r.id))}
          showSelectAll
          showColumnSearch
          filterModel={filterModel}
          onFilterChanged={setFilterModel}
          onEdit={(row) => alert(`Edit: ${row.productTitle}`)}
          onCopy={(row) => alert(`Copy: ${row.productTitle}`)}
          onDuplicate={(row) => alert(`Duplicate: ${row.productTitle}`)}
          onDelete={(row) => alert(`Delete: ${row.productTitle}`)}
          moreActions={DEMO_MORE_ACTIONS}
          showMoreActions
          floatingActions={DEMO_FLOATING_ACTIONS}
          pagination
          paginationPageSize={5}
          paginationPageSizeSelector={[5, 10, 25]}
          height="500px"
        />

        <h4 className="mt-4">AG-Grid — Validated Cell (inline error + character count)</h4>
        <AGValidatedCellDemo />

        <h4 className="mt-4">CommonAGGridTable — Set-up Costs demo</h4>
        <CommonAGGridTableDemo />

        <h4 className="mt-4">CommonAGGridTable — Row Expand demo (product → colourways)</h4>
        <p className="f-12 text-muted mb-2">
          Click the chevron on a master row to reveal its colourway sub-rows. Rows with no colourways have the chevron suppressed via <code>isRowMaster</code>.
        </p>
        <CommonAGGridTableExpandDemo />

        <h4 className="mt-4">CommonAGGridTable — Tree-data Expand (Range-Plan style)</h4>
        <p className="f-12 text-muted mb-2">
          Children share the parent&apos;s column grid. The chevron lives in AG-Grid&apos;s auto-group column and indents per tree depth. Enabled with{' '}
          <code>treeData</code> + <code>getDataPath</code>.
        </p>
        <CommonAGGridTableTreeExpandDemo />

        <h4 className="mt-3">{t('UTILITY.COLLAPSE_CARD')}</h4>
        <div className="row">
          <div className="col-md-12">
            <CollapseCard />
          </div>
        </div>
        <h4 className="mt-3">{t('UTILITY.TABS')}</h4>

        {/* Button Variation */}
        <div className="row mt-4">
          <div className="col-lg-12 d-flex">
            <button className="btn btn-default">{t('UTILITY.BUTTON_SAVE')}</button>
            <button className="btn btn-default ml-2">
              <span className="icon-Save mr-1" />
              {t('UTILITY.BUTTON_SAVE')}
            </button>
            <button className="btn btn-white ml-2">
              <i className="icon-Save mr-1" />
              {t('UTILITY.SAVE')}
            </button>
            <button className="btn btn-outline">
              <i className="icon-upload" />
            </button>
          </div>
        </div>
        {/* Button Variation END */}
      </div>
    </>
  );
}

export default Utility;
